import React from 'react';

type LoadingProps = {};

export const Loading: React.FC<LoadingProps> = () => {
  return <div>Loading...</div>;
};

export default Loading;
